module.exports = __webpack_public_path__ + "static/media/iPad.73bebb30.png";